import { create } from "zustand";
import { persist } from "zustand/middleware";
import type { CurrentUser } from "../api/types";

type AuthState = {
  accessToken: string | null;
  refreshToken: string | null;
  user: CurrentUser | null;
  hydrated: boolean;
  setHydrated: (hydrated: boolean) => void;
  setSession: (payload: { accessToken: string; refreshToken?: string | null; user?: CurrentUser | null }) => void;
  setToken: (accessToken: string | null) => void;
  clearSession: () => void;
};

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      accessToken: null,
      refreshToken: null,
      user: null,
      hydrated: false,
      setHydrated: (hydrated) => set({ hydrated }),
      setSession: ({ accessToken, refreshToken, user }) => set({ accessToken, refreshToken: refreshToken ?? null, user: user ?? null, hydrated: true }),
      setToken: (accessToken) => set({ accessToken }),
      clearSession: () => set({ accessToken: null, refreshToken: null, user: null, hydrated: true })
    }),
    { name: "accounting-spa-auth" }
  )
);
